// ----------------------------------------------------------------------

export const _pricingPlans = [
  {
    subscription: 'basic',
    prices: {
      '3month': 699,
      '6month': 599,
      '1year': 499,
    },
    caption: 'Everything needed to get started',
    lists: [
      '1 admin user',
      '2 standard users',
      'RBAC management',
      '1 EE, ME, and FW tool integration',
      'Full inventory & workflow management',
    ],
    labelAction: 'Current plan',
    additionalUsers: {
      '3month': {
        user: 179,
        admin: 199,
      },
      '6month': {
        user: 149,
        admin: 169,
      },
      '1year': {
        user: 99,
        admin: 119,
      },
    },
  },
  {
    subscription: 'agentic',
    prices: {
      '3month': 999,
      '6month': 799,
      '1year': 699,
    },
    caption: 'Unlock more productivity',
    lists: [
      'Everything in Basic',
      '4 boards',
      'Workflow agents',
      'Generic agents',
      '500 credits per month',
    ],
    labelAction: 'Choose starter',
    additionalUsers: {
      '3month': {
        user: 209,
        admin: 229,
      },
      '6month': {
        user: 159,
        admin: 179,
      },
      '1year': {
        user: 129,
        admin: 149,
      },
    },
  },
  {
    subscription: 'intelligent',
    prices: {
      '3month': 1399,
      '6month': 1199,
      '1year': 999,
    },
    caption: 'Unlock the most productivity',
    lists: [
      'Everything in Agentic',
      'Unlimited boards',
      'Up to 20 team members',
      'Advanced analytics',
      '24/7 premium support',
    ],
    labelAction: 'Choose premium',
    additionalUsers: {
      '3month': {
        user: '...',
        admin: '...',
      },
      '6month': {
        user: '...',
        admin: '...',
      },
      '1year': {
        user: '...',
        admin: '...',
      },
    },
  },
];
